import React from "react";

export default function ({tips = []}) {
    if (tips.length) {
        return (
            <div className='tips'>
                <div className='title'>Tips</div>
                {tips.map((tip, index) => (
                    <div key={index}>{tip}</div>
                ))}
            </div>
        );
    }

    return null;
}
